import VuetifySettings from './VuetifySettings'

export default class VuetifyTheme {
  public primary?: VuetifySettings
  public secondary?: VuetifySettings
  public tertiary?: VuetifySettings
  public error?: VuetifySettings
  public success?: VuetifySettings
  public warning?: VuetifySettings
  public borderRadius?: number

  constructor({ primary, secondary, tertiary, error, success, warning, borderRadius }) {
    this.primary = primary
    this.secondary = secondary
    this.tertiary = tertiary
    this.error = error
    this.success = success
    this.warning = warning
    this.borderRadius = borderRadius
  }

  cssProperties() {
    const primaryProperties = this.primary ? this.primary.cssProperties() : {}
    const secondaryProperties = this.secondary ? this.secondary.cssProperties() : {}
    const tertiaryProperties = this.tertiary ? this.tertiary.cssProperties() : {}
    const errorProperties = this.error ? this.error.cssProperties() : {}
    const successProperties = this.success ? this.success.cssProperties() : {}
    const warningProperties = this.warning ? this.warning.cssProperties() : {}

    return {
      ...primaryProperties,
      ...secondaryProperties,
      ...tertiaryProperties,
      ...errorProperties,
      ...warningProperties,
      ...successProperties,
      '--v-border-radius': `${this.borderRadius}`,
    }
  }
}
